<template>
  <div>
    <v-container class="app-breadcrumbs-container">
      <v-breadcrumbs class="app-breadcrumbs" :items="breadcrumbs">
        <v-icon slot="divider">chevron_right</v-icon>
        <template slot="item" slot-scope="props">
          <router-link
            :to="props.item.to"
            :class="[
              props.item.disabled && 'v-breadcrumbs__item--disabled',
              'app-breadcrumbs__item'
            ]"
          >
            {{ props.item.text }}
          </router-link>
        </template>
      </v-breadcrumbs>
    </v-container>
    <div class="main-title">
      <v-container fill-height>
        <v-layout align-center>
          {{ $t("login.title") }}
        </v-layout>
      </v-container>
    </div>
    <v-container>
      <v-container class="login-container">
        <v-layout>
          <v-flex>
            <div>
              {{ $t("login.tip") }}
            </div>
          </v-flex>
        </v-layout>

        <v-form ref="form">
          <v-container>
            <v-layout :column="breakpoint.smAndDown">
              <v-flex xs6>
                <v-text-field
                  v-model="email"
                  ref="email"
                  :rules="emailRules"
                  validate-on-blur
                  :label="$t('login.email_label')"
                  required
                  clearable
                ></v-text-field>
              </v-flex>

              <v-flex xs6>
                <v-text-field
                  v-model="password"
                  ref="password"
                  :rules="nameRules"
                  validate-on-blur
                  :label="$t('login.pwd_label')"
                  required
                  :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                  @click:append="showPassword = !showPassword"
                  :type="showPassword ? 'text' : 'password'"
                  clearable
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-layout column>
          <v-flex>
            <button class="button shadow login-btn" @click="submit">
              {{ $t("login.btn") }}
            </button>
            <router-link
              class="button shadow register-btn"
              :to="{ name: 'register' }"
            >
              {{ $t("login.register_btn") }}
            </router-link>
          </v-flex>
          <v-flex>
            <router-link
              class="lost_password"
              :to="{ name: 'forget-password' }"
            >
              {{ $t("login.lost_pwd") }}
            </router-link>
          </v-flex>
        </v-layout>
        <v-layout column class="other-login">
          <div class="label">{{ $t("login.sign_with") }}</div>

          <g-signin-button
            :params="googleSignInParams"
            @success="onSignInSuccess"
            @error="onSignInError"
          >
            <div class="btn">
              <img src="../../assets/google.png" class="icon" />
            </div>
          </g-signin-button>
        </v-layout>
      </v-container>
    </v-container>
    <v-dialog v-model="passwordTip" width="500">
      <v-card>
        <v-card-title>
          <span>{{ tip }}</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn color="primary" flat @click="passwordTip = false">
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import account from "@/api/account";

export default {
  data() {
    return {
      email: "",
      password: "",
      nameRules: [value => !!value || this.$t("login.rules")],
      emailRules: [
        value => !!value || this.$t("login.rules"),
        value =>
          /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/.test(
            value
          ) || this.$t("common.email_rule")
      ],
      showPassword: false,
      passwordTip: false,
      tip: this.$t("password.pwd_same"),
      googleSignInParams: {
        client_id:
          "1067445221307-hhaie1fo802sntc7mkngubqd368r7h7r.apps.googleusercontent.com"
      }
    };
  },

  computed: {
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("breadcrumbs.home")
        },
        {
          disabled: true,
          text: this.$t("breadcrumbs.login"),
          to: { name: "login" }
        }
      ];
    },
    form() {
      return {
        email: this.email,
        password: this.password
      };
    },
    breakpoint() {
      console.log(this.$vuetify.breakpoint);
      return this.$vuetify.breakpoint;
    }
  },

  methods: {
    ...mapMutations(["setGuid", "setTokenContent", "setUserInfo", "login"]),
    submit() {
      let isFull = true;
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) {
          this.formHasErrors = true;
          this.$refs[f].validate(true);
          isFull = false;
        }
      });

      if (isFull) {
        this.handleLogin();
      }
    },
    async handleLogin() {
      try {
        const res = await account.login(this.form);

        if (!res.data.isError) {
          this.login();
          this.setGuid(res.data.data.guid);
          this.setTokenContent(res.data.data.tokenContent);
          const user_res = await account.loadCustomer();

          if (!user_res.data.isError) {
            this.setUserInfo(user_res.data.data);

            setTimeout(() => {
              this.$router.push({ name: "home" });
            }, 500);
          }
        } else {
          this.tip = res.data.msg;
          this.passwordTip = true;
        }
      } catch (e) {
        this.tip = e.response.data.msg;
        this.passwordTip = true;
      }
    },

    async onSignInSuccess(googleUser) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users
      // const profile = googleUser.getBasicProfile(); // etc etc

      let id_token;
      for (const [key] of Object.entries(googleUser)) {
        console.log(googleUser[key]);
        if (googleUser[key] && googleUser[key].id_token) {
          id_token = googleUser[key].id_token;
        }
      }

      const res = await account.googleLogin({
        id_token,
        is_web: 1
      });

      if (!res.data.isError) {
        this.login();
        this.setTokenContent(res.data.data.tokenContent);
        const user_res = await account.loadCustomer();

        if (!user_res.data.isError) {
          this.setUserInfo(user_res.data.data);
          this.setGuid(user_res.data.data.guid);

          setTimeout(() => {
            this.$router.push({ name: "home" });
          }, 500);
        }
      } else {
        this.tip = res.data.msg;
        this.passwordTip = true;
      }
    },
    onSignInError(error) {
      // `error` contains any error occurred.
      console.log("OH NOES", error);
    }
  }
};
</script>

<style scoped lang="sass" src="./login.sass"></style>
